import { React, useEffect, useState } from "react";
import axios from "axios";
import {
  RightLayoutContainer,
  PageTitleComp,
  ContentMiddle,
} from "../styledElements";
import { Button, PageHeader } from "antd";
import Iconmoon from "../../Components/IconsFiles/icon";
import { useLocation, useNavigate } from "react-router-dom";
import JobcardPrepare from "../../Components/IconsFiles/preparing_job_card";
import LottieAnimation from "../../Lottie";
import {
    getAllOrdersList,
    getFilteredOrders,
    searchOrderRecords,
  } from "../../Services/orderServices";
  import {
    getApprovedOrdersList,
    getFilteredApproveOrders,
    searchApproveOrderRecords,
  } from "../../Services/orderServices";
  import {
    getDeckleOrdersList,
    getFilteredDeckleOrders,
    getCount
  } from "../../Services/orderServices";
  import {
    getFilteredProductionDetails,
    getProductionDetails,
    searchProductionDetails,
    exportMultistageDetails,
    exportSearchProdMultistageDetails
  } from "../../Services/productionPlanningServices";
  import { searchDeckleMatchOrders } from "../../Services/deckleMatchServices";
  import {
    getAllUsers,
    getFilteredUsers,
    getSearchedUsers,
  } from "../../Services/loginServices";
  import {
    getCustomersForConfiguration,
    searchCustomers,
    getFilteredCustomers,
  } from "../../Services/customerServices";
  import {
    paperMachineListDataForConfiguration,
    searchMachines,
    getFilteredMachines,
  } from "../../Services/machineServices";
  import {
    getProductsDataForConfiguration,
    searchProducts,
    getFilteredProducts,
  } from "../../Services/productServices";
  import {
    getCuttersRecords,
    searchCutters,
    getFilteredCutters,
    getRewinderRecords,
    searchRewinders,
    getFilteredRewinders
  } from "../../Services/machineServices";

  const ExportRecordsAnimation = (props) => {
    const history = useNavigate();
    const location = useLocation();
    const source = axios.CancelToken.source();

    useEffect(() => {
      return()=>{
        source.cancel("Page is redirected")
      }
    },[])

    useEffect(async () => {
      let page = location?.state?.body?.page;
      let type = location?.state?.body?.type;
      let status = location?.state?.body?.status;
      let searchValue = location?.state?.body?.searchValue;
      let appliedFilters = location?.state?.body?.appliedFilters;
      let paginationParams = location?.state?.body?.paginationParams;
      let sortParams = location?.state?.body?.sortParams;
      let params = location?.state?.body?.params;
      let orderType = location?.state?.body?.orderType ? location?.state?.body?.orderType : undefined;
      let priority = "";
      if(page && type){
        if(page === "order records"){
          if(type === "All Data"){
            if(location?.state.count){
              let orderDataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                getAllOrdersList(startEndParams, sortParams, status, source).then((response) => {
                  if(response){
                    orderDataArr = orderDataArr.concat(response.orders);
                    if(location?.state.count === orderDataArr.length){
                        history("../order-records/export-orders", {
                          state: {
                            body: location?.state?.body,
                            rootPage: "../order-records",
                            fileName: location?.state?.fileName,
                            orderMangtRecords: orderDataArr,
                            switchReelCoreOD: location?.state?.switchReelCoreOD,
                            switchOrderFormat:
                              location?.state?.switchOrderFormat,
                            switchPlannedWt: location?.state?.switchPlannedWt,
                            switchPlannedReels:
                              location?.state?.switchPlannedReels,
                            switchPrice: location?.state?.switchPrice,
                            switchAddress: location?.state?.switchAddress,
                            shippingAddress: location?.state?.shippingAddress,
                            billingAddress: location?.state?.billingAddress,
                            switchApprover: location?.state?.switchApprover,
                            switchCreatedBy: location?.state?.switchCreatedBy,
                            switchDeliveryDate: location?.state?.switchDeliveryDate,
                            switchCreatedDate: location?.state?.switchCreatedDate,
                            switchStatus: location?.state?.switchStatus,
                            switchPriority: location?.state?.switchPriority,
                            switchQtyPlanned: location?.state?.switchQtyPlanned,
                            switchPackaging: location?.state?.switchPackaging,
                            switchDiameter: location?.state?.switchDiameter,
                            switchProductName:
                              location?.state?.switchProductName,
                            exportOrderDetail:
                              location?.state?.exportOrderDetail,
                          },
                        });
                    }
                  }
                }).catch((error) => {
                    history("../order-records");
                });
              }
            }
          } else if(type === "Search"){
            if(location?.state.count){
              let orderDataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                searchOrderRecords(searchValue, status, source, sortParams, startEndParams).then((response) => {
                  if(response){
                    orderDataArr = orderDataArr.concat(response.data);
                    if(location?.state.count === orderDataArr.length){
                        history("../order-records/export-orders", {
                          state: {
                            body: location?.state?.body,
                            rootPage: "../order-records",
                            fileName: location?.state?.fileName,
                            orderMangtRecords: response.data,
                            switchReelCoreOD: location?.state?.switchReelCoreOD,
                            switchOrderFormat:
                              location?.state?.switchOrderFormat,
                            switchPlannedWt: location?.state?.switchPlannedWt,
                            switchPlannedReels:
                              location?.state?.switchPlannedReels,
                            switchPrice: location?.state?.switchPrice,
                            switchAddress: location?.state?.switchAddress,
                            shippingAddress: location?.state?.shippingAddress,
                            billingAddress: location?.state?.billingAddress,
                            switchApprover: location?.state?.switchApprover,
                            switchCreatedBy: location?.state?.switchCreatedBy,
                            switchDeliveryDate: location?.state?.switchDeliveryDate,
                            switchCreatedDate: location?.state?.switchCreatedDate,
                            switchStatus: location?.state?.switchStatus,
                            switchPriority: location?.state?.switchPriority,
                            switchQtyPlanned: location?.state?.switchQtyPlanned,
                            switchPackaging: location?.state?.switchPackaging,
                            switchDiameter: location?.state?.switchDiameter,
                            switchProductName:
                              location?.state?.switchProductName,
                            exportOrderDetail:
                              location?.state?.exportOrderDetail,
                          },
                        });
                    }
                  }
                }).catch((error) => {
                    history("../order-records");
                });
              }
            }
          } else if(type === "Filter"){
            if(location?.state.count){
              let orderDataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                getFilteredOrders(appliedFilters, startEndParams, sortParams, status, priority, source,searchValue).then((response) => {
                  if(response){
                    orderDataArr = orderDataArr.concat(response.data);
                    if(location?.state.count === orderDataArr.length){
                        history("../order-records/export-orders", {
                                    state: {
                                        body: location?.state?.body,
                                        rootPage: "../order-records",
                                        fileName: location?.state?.fileName,
                                        orderMangtRecords: orderDataArr,
                                        switchReelCoreOD: location?.state?.switchReelCoreOD,
                                        switchOrderFormat: location?.state?.switchOrderFormat,
                                        switchPlannedWt: location?.state?.switchPlannedWt,
                                        switchPlannedReels: location?.state?.switchPlannedReels,
                                        switchPrice: location?.state?.switchPrice,
                                        switchAddress: location?.state?.switchAddress,
                                        shippingAddress: location?.state?.shippingAddress,
                                        billingAddress: location?.state?.billingAddress,
                                        switchApprover: location?.state?.switchApprover,
                                        switchCreatedBy: location?.state?.switchCreatedBy,
                                        switchDeliveryDate: location?.state?.switchDeliveryDate,
                                        switchCreatedDate: location?.state?.switchCreatedDate,
                                        switchStatus: location?.state?.switchStatus,
                                        switchPriority: location?.state?.switchPriority,
                                        switchProductName: location?.state?.switchProductName,
                                        switchQtyPlanned: location?.state?.switchQtyPlanned,
                                        switchPackaging: location?.state?.switchPackaging,
                                        switchDiameter: location?.state?.switchDiameter,
                                        exportOrderDetail: location?.state?.exportOrderDetail
                                      },
                        })
                    }
                  }
                }).catch((error) => {
                    history("../order-records");
                });
              }
            }
          }
        } else if(page === "approve order records"){
          if(type === "All Data"){
            if(location?.state.count){
              let orderDataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                getApprovedOrdersList(startEndParams, sortParams, status, source).then((response) => {
                  if(response){
                    orderDataArr = orderDataArr.concat(response.orders);
                    if(location?.state.count === orderDataArr.length){
                      history("../approve-records/export-orders", {
                              state: {
                                  body: location?.state?.body,
                                  rootPage: "../approve-records",
                                  fileName: location?.state?.fileName,
                                  orderMangtRecords: orderDataArr,
                                  switchReelCoreOD: location?.state?.switchReelCoreOD,
                                  switchOrderFormat: location?.state?.switchOrderFormat,
                                  switchPlannedWt: location?.state?.switchPlannedWt,
                                  switchPlannedReels: location?.state?.switchPlannedReels,
                                  switchPrice: location?.state?.switchPrice,
                                  switchAddress: location?.state?.switchAddress,
                                  shippingAddress: location?.state?.shippingAddress,
                                  billingAddress: location?.state?.billingAddress,
                                  switchApprover: location?.state?.switchApprover,
                                  switchCreatedBy: location?.state?.switchCreatedBy,
                                  switchDeliveryDate: location?.state?.switchDeliveryDate,
                                  switchCreatedDate: location?.state?.switchCreatedDate,
                                  switchStatus: location?.state?.switchStatus,
                                  switchPriority: location?.state?.switchPriority,
                                  switchProductName: location?.state?.switchProductName,
                                  switchQtyPlanned: location?.state?.switchQtyPlanned,
                                  switchPackaging: location?.state?.switchPackaging,
                                  switchDiameter: location?.state?.switchDiameter,
                                  exportOrderDetail: location?.state?.exportOrderDetail
                                },
                            })
                    }
                  }
                }).catch((error) => {
                  history("../order-records");
              });
              }
            }
          } else if(type === "Filter"){
            if(location?.state.count){
              let orderDataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                getFilteredApproveOrders(
                    appliedFilters,
                    startEndParams,
                    sortParams,
                    status,
                    priority,
                    source
                    ).then((response) => {
                      if(response){
                        orderDataArr = orderDataArr.concat(response.data.orders);
                        if(location?.state.count === orderDataArr.length){
                          history("../approve-records/export-orders", {
                                    state: {
                                        body: location?.state?.body,
                                        rootPage: "../approve-records",
                                        fileName: location?.state?.fileName,
                                        orderMangtRecords: orderDataArr,
                                        switchReelCoreOD: location?.state?.switchReelCoreOD,
                                        switchOrderFormat: location?.state?.switchOrderFormat,
                                        switchPlannedWt: location?.state?.switchPlannedWt,
                                        switchPlannedReels: location?.state?.switchPlannedReels,
                                        switchPrice: location?.state?.switchPrice,
                                        switchAddress: location?.state?.switchAddress,
                                        shippingAddress: location?.state?.shippingAddress,
                                        billingAddress: location?.state?.billingAddress,
                                        switchApprover: location?.state?.switchApprover,
                                        switchCreatedBy: location?.state?.switchCreatedBy,
                                        switchDeliveryDate: location?.state?.switchDeliveryDate,
                                        switchCreatedDate: location?.state?.switchCreatedDate,
                                        switchStatus: location?.state?.switchStatus,
                                        switchPriority: location?.state?.switchPriority,
                                        switchProductName: location?.state?.switchProductName,
                                        switchQtyPlanned: location?.state?.switchQtyPlanned,
                                        switchPackaging: location?.state?.switchPackaging,
                                        switchDiameter: location?.state?.switchDiameter,
                                        exportOrderDetail: location?.state?.exportOrderDetail
                                      },
                                  })
                        }
                      }
                    }).catch((error) => {
                        history("../approve-records");
                      });
              }
            }
          } else if(type === "Search"){
            if(location?.state.count){
              let orderDataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                searchApproveOrderRecords(searchValue, status, source, sortParams, startEndParams).then((response) => {
                  if(response){
                    orderDataArr = orderDataArr.concat(response.data);
                    if(location?.state.count === orderDataArr.length){
                      history("../approve-records/export-orders", {
                              state: {
                                  body: location?.state?.body,
                                  rootPage: "../approve-records",
                                  fileName: location?.state?.fileName,
                                  orderMangtRecords: orderDataArr,
                                  switchReelCoreOD: location?.state?.switchReelCoreOD,
                                  switchOrderFormat: location?.state?.switchOrderFormat,
                                  switchPlannedWt: location?.state?.switchPlannedWt,
                                  switchPlannedReels: location?.state?.switchPlannedReels,
                                  switchPrice: location?.state?.switchPrice,
                                  switchAddress: location?.state?.switchAddress,
                                  shippingAddress: location?.state?.shippingAddress,
                                  billingAddress: location?.state?.billingAddress,
                                  switchApprover: location?.state?.switchApprover,
                                  switchCreatedBy: location?.state?.switchCreatedBy,
                                  switchDeliveryDate: location?.state?.switchDeliveryDate,
                                  switchCreatedDate: location?.state?.switchCreatedDate,
                                  switchStatus: location?.state?.switchStatus,
                                  switchPriority: location?.state?.switchPriority,
                                  switchProductName: location?.state?.switchProductName,
                                  switchQtyPlanned: location?.state?.switchQtyPlanned,
                                  switchPackaging: location?.state?.switchPackaging,
                                  switchDiameter: location?.state?.switchDiameter,
                                  exportOrderDetail: location?.state?.exportOrderDetail
                                },
                            })
                    }
                  }
                }).catch((error) => {
                    history("../approve-records");
                  });
              }
            }
          }        
        } else if(page === "deckle order records"){
          if(type === "All Data"){
              if(location?.state.count){
                sortParams = {
                  sort_by: "po__date",
                  sort_type: "ascending"
                };
                let deckleDataArr = [];
                for(let i = 0; i <= location?.state.count; i+= 500){
                    let start = i;
                    let end = i + 500;
                    let startEndParams = {
                      start: start,
                      end: end
                    }
                    getDeckleOrdersList(startEndParams,sortParams="", status, source, orderType).then((response) => {
                      if(response){
                        deckleDataArr = deckleDataArr.concat(response?.orders?.[status]);
                        if(location?.state.count === deckleDataArr.length){
                            history("../order-records/export-orders", {
                              state: {
                                      body: location?.state?.body,
                                      rootPage: "../order-records",
                                      fileName: location?.state?.fileName,
                                      deckleOrders: deckleDataArr,
                                      switchReelCoreOD: location?.state?.switchReelCoreOD,
                                      switchOrderFormat: location?.state?.switchOrderFormat,
                                      switchPlannedWt: location?.state?.switchPlannedWt,
                                      switchPlannedReels: location?.state?.switchPlannedReels,
                                      switchPrice: location?.state?.switchPrice,
                                      switchAddress: location?.state?.switchAddress,
                                      shippingAddress: location?.state?.shippingAddress,
                                      billingAddress: location?.state?.billingAddress,
                                      switchApprover: location?.state?.switchApprover,
                                      switchCreatedBy: location?.state?.switchCreatedBy,
                                      switchDeliveryDate: location?.state?.switchDeliveryDate,
                                      switchCreatedDate: location?.state?.switchCreatedDate,
                                      switchStatus: location?.state?.switchStatus,
                                      switchPriority: location?.state?.switchPriority,
                                      switchProductName: location?.state?.switchProductName,                                     
                                      switchQtyPlanned: location?.state?.switchQtyPlanned,
                                      switchPackaging: location?.state?.switchPackaging,
                                      switchDiameter: location?.state?.switchDiameter,
                                      exportOrderDetail: location?.state?.exportOrderDetail
                                    },
                            })
                        }
                      }    
                    }).catch((error) => {
                      history("../order-records");
                    });
                }
              }
          } else if(type === "Filter"){
            if(location?.state.count){
              sortParams = {
                sort_by: "po__date",
                sort_type: "ascending"
              };
              let deckleDataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                getFilteredDeckleOrders(appliedFilters, paginationParams = "", sortParams, status, startEndParams, source).then((response) => {
                  if(response){
                    if(status === "incomplete_orders"){
                      deckleDataArr = deckleDataArr.concat(response?.data?.orders[status]);
                    } else{
                      deckleDataArr = deckleDataArr.concat(response?.data?.orders[status]);
                    }
                    if(location?.state.count === deckleDataArr.length){
                        history("../order-records/export-orders", {
                          state: {
                                  body: location?.state?.body,
                                  rootPage: "../order-records",
                                  fileName: location?.state?.fileName,
                                  deckleOrders: deckleDataArr,
                                  switchReelCoreOD: location?.state?.switchReelCoreOD,
                                  switchOrderFormat: location?.state?.switchOrderFormat,
                                  switchPlannedWt: location?.state?.switchPlannedWt,
                                  switchPlannedReels: location?.state?.switchPlannedReels,
                                  switchPrice: location?.state?.switchPrice,
                                  switchAddress: location?.state?.switchAddress,
                                  shippingAddress: location?.state?.shippingAddress,
                                  billingAddress: location?.state?.billingAddress,
                                  switchApprover: location?.state?.switchApprover,
                                  switchCreatedBy: location?.state?.switchCreatedBy,
                                  switchDeliveryDate: location?.state?.switchDeliveryDate,
                                  switchCreatedDate: location?.state?.switchCreatedDate,
                                  switchStatus: location?.state?.switchStatus,
                                  switchPriority: location?.state?.switchPriority,
                                  switchProductName: location?.state?.switchProductName,                                     
                                  switchQtyPlanned: location?.state?.switchQtyPlanned,
                                  switchPackaging: location?.state?.switchPackaging,
                                  switchDiameter: location?.state?.switchDiameter,
                                  exportOrderDetail: location?.state?.exportOrderDetail
                                },
                        })
                    }
                  }
                }).catch((error) => {
                history("../order-records");
              });
              }
            }
          } else if(type === "Search"){
            if(location?.state.count){
              sortParams = {
                sort_by: "po__date",
                sort_type: "ascending"
              };
              let deckleDataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                searchDeckleMatchOrders(searchValue, source, status, startEndParams).then((response) => {
                  if(response){
                    deckleDataArr = deckleDataArr.concat(response?.data[status]);
                    if(location?.state.count === deckleDataArr.length){
                        history("../order-records/export-orders", {
                                state: {
                                      body: location?.state?.body,
                                      rootPage: "../order-records",
                                      fileName: location?.state?.fileName,
                                      deckleOrders: deckleDataArr,
                                      switchReelCoreOD: location?.state?.switchReelCoreOD,
                                      switchOrderFormat: location?.state?.switchOrderFormat,
                                      switchPlannedWt: location?.state?.switchPlannedWt,
                                      switchPlannedReels: location?.state?.switchPlannedReels,
                                      switchPrice: location?.state?.switchPrice,
                                      switchAddress: location?.state?.switchAddress,
                                      shippingAddress: location?.state?.shippingAddress,
                                      billingAddress: location?.state?.billingAddress,
                                      switchApprover: location?.state?.switchApprover,
                                      switchCreatedBy: location?.state?.switchCreatedBy,
                                      switchDeliveryDate: location?.state?.switchDeliveryDate,
                                      switchCreatedDate: location?.state?.switchCreatedDate,
                                      switchStatus: location?.state?.switchStatus,
                                      switchPriority: location?.state?.switchPriority,
                                      switchProductName: location?.state?.switchProductName,                                     
                                      switchQtyPlanned: location?.state?.switchQtyPlanned,
                                      switchPackaging: location?.state?.switchPackaging,
                                      switchDiameter: location?.state?.switchDiameter,
                                      exportOrderDetail: location?.state?.exportOrderDetail
                                    },
                        })
                    }
                  }
                }).catch((error) => {
                      history("../order-records");
                });
              }
            }
          }
        } else if(page === "production details"){
          if(type === "All Data"){
            if(location?.state.count){
              let dataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                exportMultistageDetails(appliedFilters, startEndParams, sortParams, source).then((resp) => {
                  if(resp){
                    dataArr = dataArr.concat(resp?.data?.data.reels);
                    if(location?.state.count === dataArr.length){
                      history("../production-detail/export-production-details", {
                        state: {
                            body: location?.state?.body,
                            rootPage: "../production-detail",
                            fileName: location?.state?.fileName,
                            productionData: dataArr,
                            exportProductionDetail: location?.state?.exportProductionDetail
                          },
                      })
                    }
                  }
                }).catch((error) => {
                      history("../production-detail");
                });
              }
            }
           } else if(type === "Filter"){
            if(location?.state.count){
              let dataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                exportMultistageDetails(appliedFilters, startEndParams, sortParams, source).then((resp) => {
                    if(resp){
                      dataArr = dataArr.concat(resp?.data?.data.reels);
                      if(location?.state.count === dataArr.length){
                        history("../production-detail/export-production-details", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../production-detail",
                              fileName: location?.state?.fileName,
                              productionData: dataArr,
                              exportProductionDetail: location?.state?.exportProductionDetail
                            },
                        })
                      }
                    }
                }).catch((error) => {
                      history("../production-detail");
                });
              }
            }
          } else if(type === "Search"){
            if(location?.state.count){
              let dataArr = [];
              for(let i = 0; i <= location?.state.count; i+= 500){
                let start = i;
                let end = i + 500;
                let startEndParams = {
                  start: start,
                  end: end
                }
                exportSearchProdMultistageDetails(appliedFilters, startEndParams, sortParams, searchValue, source).then((resp) => {
                  if(resp){
                    dataArr = dataArr.concat(resp?.data?.data.reels);
                    if(location?.state.count === dataArr.length){
                      history("../production-detail/export-production-details", {
                        state: {
                            body: location?.state?.body,
                            rootPage: "../production-detail",
                            fileName: location?.state?.fileName,
                            productionData: dataArr,
                            exportProductionDetail: location?.state?.exportProductionDetail
                          },
                      })
                    }
                  }
                }).catch((error) => {
                  history("../production-detail");
                });
              }
            }
          }
        } else if(page === "user records"){
          if(type === "All Data"){
            try{
              const getUsers = await getAllUsers(source);
              if(getUsers?.length){
                history("/organization-setting/user-management/export-user", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "/organization-setting/user-management",
                              fileName: location?.state?.fileName,
                              userRecords: getUsers,
                              exportUserDetail: location?.state?.exportUserDetail
                            },
                      })
              }
            }
            catch{
              history("/organization-setting/user-management");
            }
          } else if(type === "Filter"){
            getFilteredUsers(appliedFilters,source).then((response) => {
              if(response){
                history("/organization-setting/user-management/export-user", {
                  state: {
                    body: location?.state?.body,
                    rootPage: "/organization-setting/user-management",
                    fileName: location?.state?.fileName,
                    userRecords: response?.data,
                    exportUserDetail: location?.state?.exportUserDetail
                    },
                })
              }
              }).catch((error) => {
              history("/organization-setting/user-management");
            });
        } else if(type === "Search"){
          getSearchedUsers(searchValue, source).then((response) => {
            if(response){
              history("/organization-setting/user-management/export-user", {
                state: {
                  body: location?.state?.body,
                  rootPage: "/organization-setting/user-management",
                  fileName: location?.state?.fileName,
                  userRecords: response,
                  exportUserDetail: location?.state?.exportUserDetail
                  },
              })
            }
            }).catch((error) => {
            history("/organization-setting/user-management");
          });
      }
        } else if(page === "customer records"){
          if(type === "All Data"){
            getCustomersForConfiguration(params="", source).then((response)=> {
              if(response){
                history("../customer-records/export-customer", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../customer-records",
                              fileName: location?.state?.fileName,
                              customerRecords: response,
                              businessDetail: location?.state?.businessDetail,
                              deliveryDetail: location?.state?.deliveryDetail,
                              exportCustomerDetail: location?.state?.exportCustomerDetail
                            },
                      })
              }
            }).catch((error) => {
              history("../customer-records");
            });
          } else if(type === "Filter"){
            getFilteredCustomers(null, appliedFilters, source,searchValue).then((response) => {
              if(response){
                history("../customer-records/export-customer", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../customer-records",
                              fileName: location?.state?.fileName,
                              customerRecords: response?.data,
                              businessDetail: location?.state?.businessDetail,
                              deliveryDetail: location?.state?.deliveryDetail,
                              exportCustomerDetail: location?.state?.exportCustomerDetail
                            },
                      })
              }
            }).catch((error) => {
              history("../customer-records");
            });
          } else if(type === "Search"){
              searchCustomers(searchValue, params, source).then((response) => {
                if(response){
                  history("../customer-records/export-customer", {
                            state: {
                                body: location?.state?.body,
                                rootPage: "../customer-records",
                                fileName: location?.state?.fileName,
                                customerRecords: response,
                                businessDetail: location?.state?.businessDetail,
                                deliveryDetail: location?.state?.deliveryDetail,
                                exportCustomerDetail: location?.state?.exportCustomerDetail
                              },
                        })
                }              
            }).catch((error) => {
              history("../customer-records");
            });
          }
        } else if(page === "machine records"){
          if(type === "All Data"){
            paperMachineListDataForConfiguration(params="", source).then((response)=> {
              if(response){
                history("../machine-records/export-machine", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../machine-records",
                              fileName: location?.state?.fileName,
                              machineRecords: response,
                              exportMachineDetail: location?.state?.exportMachineDetail
                            },
                      })
              }
            }).catch((error) => {
              history("../machine-records");
            });
          } else if(type === "Filter"){
            getFilteredMachines(null, appliedFilters, source,searchValue).then((response) => {
              if(response){
                history("../machine-records/export-machine", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../machine-records",
                              fileName: location?.state?.fileName,
                              machineRecords: response?.data,
                              exportMachineDetail: location?.state?.exportMachineDetail
                            },
                      })
              }          
            }).catch((error) => {
              history("../machine-records");
            });
          } else if(type === "Search"){
            searchMachines(searchValue, params, source).then((response) => {
              if(response){
                history("../machine-records/export-machine", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../machine-records",
                              fileName: location?.state?.fileName,
                              machineRecords: response,
                              exportMachineDetail: location?.state?.exportMachineDetail
                            },
                      })
              }          
            }).catch((error) => {
              history("../machine-records");
            });
          }
        } else if(page === "product records"){
          if(type === "All Data"){
            getProductsDataForConfiguration(params="", source).then((response)=> {
              if(response){
                history("../products-records/export-product", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../products-records",
                              fileName: location?.state?.fileName,
                              productRecords: response,
                              priceColumn: location?.state?.priceColumn,
                              exportProductDetail: location?.state?.exportProductDetail
                            },
                      })
              }
            }).catch((error) => {
              history("../products-records");
            });
          } else if(type === "Filter"){
            getFilteredProducts(null, appliedFilters, source,searchValue).then((response) =>{
              if(response){
                history("../products-records/export-product", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../products-records",
                              fileName: location?.state?.fileName,
                              productRecords: response?.data,
                              priceColumn: location?.state?.priceColumn,
                              exportProductDetail: location?.state?.exportProductDetail
                            },
                      })
              }
            }).catch((error) => {
              history("../products-records");
            });
          } else if(type === "Search"){
            searchProducts(searchValue, params, source).then((response) => {
              if(response){
                history("../products-records/export-product", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../products-records",
                              fileName: location?.state?.fileName,
                              productRecords: response,
                              priceColumn: location?.state?.priceColumn,
                              exportProductDetail: location?.state?.exportProductDetail
                            },
                      })
              }
            }).catch((error) => {
              history("../products-records");
            });
          }
        } else if(page === "cutter records"){
          if(type === "All Data"){
            getCuttersRecords(params="", source).then((response)=> {
              if(response){
                history("../cutter-records/export-cutter", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../cutter-records",
                              fileName: location?.state?.fileName,
                              cutterRecords: response,
                              exportCutterDetail: location?.state?.exportCutterDetail
                            },
                      })
              }
            }).catch((error) => {
              history("../cutter-records");
            });
          } else if(type === "Filter"){
            getFilteredCutters(null, appliedFilters, source,searchValue).then((response) => {
              if(response){
                history("../cutter-records/export-cutter", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../cutter-records",
                              fileName: location?.state?.fileName,
                              cutterRecords: response?.data,
                              exportCutterDetail: location?.state?.exportCutterDetail                            },
                      })
              }          
            }).catch((error) => {
              history("../cutter-records");
            });
          } else if(type === "Search"){
            searchCutters(searchValue, params, source).then((response) => {
              if(response){
                history("../cutter-records/export-cutter", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../cutter-records",
                              fileName: location?.state?.fileName,
                              cutterRecords: response,
                              exportCutterDetail: location?.state?.exportCutterDetail
                            },
                      })
              }          
            }).catch((error) => {
              history("../cutter-records");
            });
          }
        } else if(page === "rewinder records"){
          if(type === "All Data"){
            getRewinderRecords(params="", source).then((response)=> {
              if(response){
                history("../rewinder-records/export-rewinder", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../rewinder-records",
                              fileName: location?.state?.fileName,
                              rewinderRecords: response,
                              exportRewinderDetail: location?.state?.exportRewinderDetail
                            },
                      })
              }
            }).catch((error) => {
              history("../rewinder-records");
            });
          } else if(type === "Filter"){
            getFilteredRewinders(null, appliedFilters, source,searchValue).then((response) => {
              if(response){
                history("../rewinder-records/export-rewinder", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../rewinder-records",
                              fileName: location?.state?.fileName,
                              rewinderRecords: response?.data,
                              exportRewinderDetail: location?.state?.exportRewinderDetail                            },
                      })
              }          
            }).catch((error) => {
              history("../rewinder-records");
            });
          } else if(type === "Search"){
            searchRewinders(searchValue, params, source).then((response) => {
              if(response){
                history("../rewinder-records/export-rewinder", {
                          state: {
                              body: location?.state?.body,
                              rootPage: "../rewinder-records",
                              fileName: location?.state?.fileName,
                              rewinderRecords: response,
                              exportRewinderDetail: location?.state?.exportRewinderDetail
                            },
                      })
              }          
            }).catch((error) => {
              history("../rewinder-records");
            });
          }
        }
    }
});

    return (
        <RightLayoutContainer>
          <PageTitleComp style={{ borderBottom: "0" }}>
            <PageHeader
              ghost={false}
              title={"Export " + location?.state?.body?.page}
              extra={[
                <Button key="1" className="textTypeBtn textBtnIcon" onClick={() => { history(location?.state?.rootPage) }}>
                  {" "}
                  <Iconmoon
                    icon="wrong"
                    size={14}
                    color="#EA4E2C"
                    style={{ marginRight: "8px", top: "1px", position: "relative" }}
                  />{" "}
                  Cancel
                </Button>,
              ]}
            ></PageHeader>
          </PageTitleComp>
          <ContentMiddle>
            <div className="imageAnimate">
              <div className="imageCover">
                <LottieAnimation lotti={JobcardPrepare} />
                <p>
                  We are exporting your {location?.state?.body?.page}, <br />
                  please wait, it will take less than a minute
                </p>
              </div>
            </div>
          </ContentMiddle>
        </RightLayoutContainer>
      );
};

export default ExportRecordsAnimation;
